import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { merge } from 'lodash-es';
import { ApiResponse } from '../../../../classes/api-response';
import { UsersService } from '../../../../services/users.service';
import { SnackService } from '../../../../services/snack.service';
import { Researcher } from "../../../../model/researcher";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'aw-researcher-form',
  templateUrl: './researcher-form.component.html',
  styleUrls: ['./researcher-form.component.scss']
})
export class ResearcherFormComponent implements OnInit {

  userForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  generalError?: ApiResponse;
  previousUrl: string;


  constructor(
    private userService: UsersService,
    private snackService: SnackService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (route.snapshot.url[0])
      this.previousUrl = route.snapshot.url[0].path;
    this.userForm = new UntypedFormGroup(
      {
        email: new UntypedFormControl(
          '',
          [
            Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"),
            Validators.required
          ]
        ),
        firstName: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.pattern('^(?!\\.)(?!.*\\.$)(?!.*?\\.\\.)(?![\\s.]+$)[a-zA-Z\\s.]*$')

          ]
        ),
        lastName: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.pattern('^(?!\\.)(?!.*\\.$)(?!.*?\\.\\.)(?![\\s.]+$)[a-zA-Z\\s.]*$')
          ]
        ),
        phone: new UntypedFormControl(
          '',
          [
            Validators.pattern('[- +()0-9]+'),
            Validators.required
          ]
        ),
        address: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        macAddress: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.pattern('^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$')
          ]
        ),
        operatingSystem: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        organizationName: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )
      },
    );



  }
  _researcher = new Researcher();

  @Input() set researcher(value: Researcher) {
    this._researcher = merge(new Researcher(), value);
    this.userForm.patchValue(this._researcher);
    if (value.id) {
      this.userForm.controls.email.disable();
    }
  }

  ngOnInit(): void {

  }

  saveUser(): void {

    this.saving = true;

    const newUser = merge(new Researcher(), this._researcher, this.userForm.value);


    this.generalError = undefined;

    if (this._researcher.id) {
      this.userService.updateResearcher(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.researcher = newUser;
            this.snackService.success('Researcher updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {
      this.userService.createResearcher(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.researcher = newUser;
            this.snackService.success('Researcher created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

  onCancel():void {

    if(this.previousUrl === 'edit')
      this.router.navigateByUrl("/reserved/profile")
    this.researcher = this._researcher;
    this.canceled.emit();

  }


}
